import React, { useState } from 'react';
import '../index.css';
import OAuthLoginButtons from "../components/login/OAuthLoginButtons";
import Logo from "../images/YavrioLogo";
import { Link } from "react-router-dom";
import { Loader2 } from 'lucide-react';

const LoginPage = () => {
    const [isLoggingIn, setIsLoggingIn] = useState(false);

    return (
        <div className="App">
            <div className='flex flex-col w-screen h-screen justify-center items-center'>
                <div className="yvr-box items-center max-w-sm !p-10 relative">
                    {isLoggingIn && (
                        <div className="absolute inset-0 z-10 flex items-center justify-center bg-white/80">
                            <Loader2 className="h-8 w-8 animate-spin text-yavrio-green" aria-label="Signing in" />
                        </div>
                    )}
                    <Logo width='12rem' />
                    <h3 className='mt-8'>Welcome</h3>
                    <p className='text-center mt-2 mb-8'>Please sign in to access the payments authorisation portal.</p>
                    <OAuthLoginButtons
                        isLoggingIn={isLoggingIn}
                        onLoggingInChange={setIsLoggingIn}
                    />
                    <Link to='mailto:support@yavr.io' className={'text-[#2E2E2E] text-sm mt-6'}>Need assistance?</Link>
                </div>
            </div>
        </div>
    );
};

export default LoginPage;